import React from 'react';
import {
    StyledReportsTableContainer,
    StyledReportsTableHeader,
    StyledReportsTableRow,
    StyledReportsTableCell,
    StyledNumber,
    StyledData,
    StyledTime
} from './styled';

const ReportsTable = ({ table }) => {
    return (
        <StyledReportsTableContainer>
            <StyledReportsTableHeader>
                {table && table.title}
            </StyledReportsTableHeader>
            <StyledReportsTableRow labels>
                <StyledReportsTableCell>
                    {table && table.column0}
                </StyledReportsTableCell>
                <StyledReportsTableCell style={{ maxWidth: '160px' }}>
                    {table && table.column1}
                </StyledReportsTableCell>
                <StyledReportsTableCell>
                    {table && table.column2}
                </StyledReportsTableCell>
            </StyledReportsTableRow>
            {table && table.data && table.data.map(({ index, number, time, note, numberBackground, rowBackground }) => (
                <StyledReportsTableRow key={index} className="report-table-note" id={`note-${index}`} rowBackground={rowBackground}>
                    <StyledReportsTableCell>
                        <StyledNumber backgroundColor={numberBackground}>
                            {number}
                        </StyledNumber>
                    </StyledReportsTableCell>
                    <StyledReportsTableCell style={{ maxWidth: '160px' }}>
                        {
                            Array.isArray(time) ? <><StyledData>{time && time[0]}</StyledData><StyledTime>{time && time[1]}</StyledTime></> : time
                        }
                    </StyledReportsTableCell>
                    <StyledReportsTableCell dangerouslySetInnerHTML={{ __html: note }} />
                </StyledReportsTableRow>
            ))}
        </StyledReportsTableContainer>
    )
}

export default ReportsTable;